(function() {
  'use strict';

  function parseVariants(root) {
    var source = root.querySelector('[data-df-variants]');

    if (!source) {
      return [];
    }

    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      return [];
    }
  }

  function initGallery(root) {
    var track = root.querySelector('[data-df-gallery-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-df-gallery-slide]'));
    var originalSlides = slides.slice();
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-df-gallery-dot]'));
    var originalDots = dots.slice();
    var dotsContainer = root.querySelector('.df-gallery__dots');
    var current = root.querySelector('[data-df-gallery-current]');
    var showImageLabel = root.getAttribute('data-df-label-show-image') || '__CURRENT__/__TOTAL__';
    var frameRequested = false;

    if (!track || !slides.length) {
      return { showFinish: function() {}, showMedia: function() {} };
    }

    function handleize(value) {
      return String(value || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function dotForSlide(slide) {
      var mediaId = slide.getAttribute('data-media-id');

      return originalDots.find(function(dot) {
        return dot.getAttribute('data-media-id') === mediaId;
      });
    }

    function applyOrder(order) {
      order.forEach(function(slide, index) {
        track.appendChild(slide);
        slide.setAttribute('data-index', String(index));
      });

      slides = order;

      if (dotsContainer) {
        dots = order.map(dotForSlide).filter(Boolean);
        dots.forEach(function(dot, index) {
          dot.setAttribute('data-index', String(index));
          dot.setAttribute('aria-label', showImageLabel
            .replace('__CURRENT__', String(index + 1))
            .replace('__TOTAL__', String(order.length)));
          dotsContainer.appendChild(dot);
        });
      }

      track.scrollLeft = 0;
      setActive(0);
    }

    function showFinish(featuredMediaId, finishValue) {
      var finish = handleize(finishValue);
      var featured = originalSlides.find(function(slide) {
        return String(slide.getAttribute('data-media-id')) === String(featuredMediaId);
      }) || originalSlides.find(function(slide) {
        return slide.getAttribute('data-df-gallery-role') === 'product' &&
          slide.getAttribute('data-df-gallery-finish') === finish;
      });
      var worn = originalSlides.find(function(slide) {
        return slide.getAttribute('data-df-gallery-role') === 'worn' &&
          slide.getAttribute('data-df-gallery-finish') === finish;
      });
      var editorial = originalSlides.filter(function(slide) {
        return slide.getAttribute('data-df-gallery-role') === 'editorial';
      });
      var preferred = [featured, worn].concat(editorial).filter(Boolean);
      var remainder = originalSlides.filter(function(slide) {
        return preferred.indexOf(slide) === -1;
      });

      applyOrder(preferred.concat(remainder));
    }

    function setActive(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));

      if (current) {
        current.textContent = String(index + 1);
      }

      dots.forEach(function(dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function updateFromScroll() {
      var trackBox = track.getBoundingClientRect();
      var targetX = trackBox.left + Math.min(trackBox.width * 0.35, 180);
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function(slide, index) {
        var slideBox = slide.getBoundingClientRect();
        var distance = Math.abs(slideBox.left - targetX + Math.min(slideBox.width * 0.35, 180));

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setActive(closestIndex);
      frameRequested = false;
    }

    track.addEventListener('scroll', function() {
      if (frameRequested) {
        return;
      }

      frameRequested = true;
      window.requestAnimationFrame(updateFromScroll);
    }, { passive: true });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = Number(dot.getAttribute('data-index')) || 0;
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setActive(index);
      });
    });

    return {
      showFinish: showFinish,
      showMedia: function(mediaId) {
        if (!mediaId) {
          return;
        }

        var index = slides.findIndex(function(slide) {
          return String(slide.getAttribute('data-media-id')) === String(mediaId);
        });

        if (index < 0) {
          return;
        }

        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setActive(index);
      }
    };
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-df-accordion-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));

        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        if (panel) {
          panel.hidden = expanded;
        }
      });
    });
  }

  function initTitleGuard(root) {
    var title = root.querySelector('[data-df-product-title]');
    var baseTitle = root.getAttribute('data-df-base-title');
    var marketingTitles = Array.prototype.slice.call(root.querySelectorAll('[data-df-stable-title]'));

    if (!title || !baseTitle) {
      return;
    }

    function restoreTitle() {
      if (title.textContent.trim() !== baseTitle) {
        title.textContent = baseTitle;
      }

      marketingTitles.forEach(function(marketingTitle) {
        var stableTitle = marketingTitle.getAttribute('data-df-stable-title');

        if (stableTitle && marketingTitle.textContent.trim() !== stableTitle) {
          marketingTitle.textContent = stableTitle;
        }
      });
    }

    restoreTitle();

    if (window.MutationObserver) {
      var titleObserver = new MutationObserver(restoreTitle);
      titleObserver.observe(root, { childList: true, subtree: true, characterData: true });
    }

    document.addEventListener('variant:change', restoreTitle);
    window.setTimeout(restoreTitle, 500);
    window.setTimeout(restoreTitle, 2000);
  }

  function initBrandCta(root) {
    var purchasePanel = root.querySelector('[data-df-purchase-panel]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-df-choose-finish]'));

    if (!purchasePanel || !buttons.length) {
      return;
    }

    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        purchasePanel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(function() {
          purchasePanel.focus({ preventScroll: true });
        }, reduceMotion ? 0 : 500);
      });
    });
  }

  function fallbackDeliveryRange() {
    var locale = document.documentElement.lang || 'en';
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5);
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 12);
    var dayFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric' });
    var monthFormatter = new Intl.DateTimeFormat(locale, { month: 'short' });
    var startDay = dayFormatter.format(start);
    var endDay = dayFormatter.format(end);
    var startMonth = monthFormatter.format(start);
    var endMonth = monthFormatter.format(end);

    if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      return startDay + '–' + endDay + ' ' + endMonth;
    }

    return startDay + ' ' + startMonth + '–' + endDay + ' ' + endMonth;
  }

  function normalizeDeliveryRange(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    var locale = document.documentElement.lang || 'en';
    var monthNumbers = {
      jan: 0, january: 0, feb: 1, february: 1, mar: 2, march: 2,
      apr: 3, april: 3, may: 4, jun: 5, june: 5, jul: 6, july: 6,
      aug: 7, august: 7, sep: 8, sept: 8, september: 8, oct: 9,
      october: 9, nov: 10, november: 10, dec: 11, december: 11
    };
    var matches = [];
    var datePattern = /(\d{1,2})\s+([A-Za-z]+)/g;
    var dateMatch;

    while ((dateMatch = datePattern.exec(text)) !== null) {
      matches.push(dateMatch);
    }

    if (matches.length < 2) {
      return '';
    }

    var now = new Date();
    var startMonth = monthNumbers[matches[0][2].toLowerCase()];
    var endMonth = monthNumbers[matches[1][2].toLowerCase()];

    if (startMonth === undefined || endMonth === undefined) {
      return '';
    }

    var startYear = now.getFullYear() + (startMonth < now.getMonth() - 6 ? 1 : 0);
    var endYear = startYear + (endMonth < startMonth ? 1 : 0);
    var start = new Date(startYear, startMonth, Number(matches[0][1]));
    var end = new Date(endYear, endMonth, Number(matches[1][1]));
    var dayFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric' });
    var monthFormatter = new Intl.DateTimeFormat(locale, { month: 'short' });

    if (startMonth === endMonth && startYear === endYear) {
      return dayFormatter.format(start) + '–' + dayFormatter.format(end) + ' ' + monthFormatter.format(end);
    }

    return dayFormatter.format(start) + ' ' + monthFormatter.format(start) + '–' +
      dayFormatter.format(end) + ' ' + monthFormatter.format(end);
  }

  function initDelivery(root, form) {
    var source = root.querySelector('#edt-p');
    var outputs = Array.prototype.slice.call(root.querySelectorAll('[data-df-delivery-date]'));

    function render(value) {
      outputs.forEach(function(output) {
        output.textContent = value;
      });
    }

    function syncFromStoreLogic() {
      var input = form && form.querySelector('.edt-product');
      var value = normalizeDeliveryRange(input && input.value);

      if (!value && source) {
        value = normalizeDeliveryRange(source.textContent);
      }

      if (value) {
        render(value);
      }
    }

    render(fallbackDeliveryRange());

    if (window.MutationObserver) {
      var observer = new MutationObserver(syncFromStoreLogic);
      observer.observe(form || root, { childList: true, subtree: true, characterData: true });
    }

    window.setTimeout(syncFromStoreLogic, 500);
    window.setTimeout(syncFromStoreLogic, 2500);
  }

  function initCoveredInfo(root) {
    var button = root.querySelector('[data-df-covered-info]');
    var detail = root.querySelector('[data-df-covered-detail]');

    if (!button || !detail || button.getAttribute('data-df-covered-bound') === 'true') {
      return;
    }

    button.setAttribute('data-df-covered-bound', 'true');

    function setOpen(open, returnFocus) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      detail.hidden = !open;

      if (!open && returnFocus) {
        button.focus();
      }
    }

    button.addEventListener('click', function() {
      setOpen(button.getAttribute('aria-expanded') !== 'true', false);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setOpen(false, true);
      }
    });

    document.addEventListener('click', function(event) {
      if (button.getAttribute('aria-expanded') === 'true' && !button.closest('[data-df-covered]').contains(event.target)) {
        setOpen(false, false);
      }
    });
  }

  function suppressLegacyPromotions() {
    var announcementText = document.getElementById('header-slider-text');
    var announcementLink = document.getElementById('header-slider-link');
    var announcementSource = document.getElementById('header-slider-source');
    var premiumPattern = /(free fedex shipping|free resizing|lifetime warranty|lifetime guarantee|30%\s*off|€\s*100|100\s*€)/i;

    if (announcementText && premiumPattern.test(announcementText.textContent || '')) {
      var safeAnnouncement = String(announcementSource && announcementSource.textContent || '')
        .split('\n')
        .map(function(line) { return line.trim(); })
        .filter(function(line) { return line && !premiumPattern.test(line); })[0];

      if (safeAnnouncement) {
        var parts = safeAnnouncement.split('~');
        announcementText.textContent = (parts[0] || '').trim();

        if (announcementLink) {
          announcementLink.href = (parts[1] || '#').trim();
        }
      }
    }
  }

  function initProduct(root) {
    if (root.getAttribute('data-df-initialized') === 'true') {
      return;
    }

    root.setAttribute('data-df-initialized', 'true');
    document.body.classList.add('template-product-demi-fine');
    suppressLegacyPromotions();
    initTitleGuard(root);
    initBrandCta(root);

    if (window.MutationObserver && !document.body.hasAttribute('data-df-promotion-observer')) {
      document.body.setAttribute('data-df-promotion-observer', 'true');

      var promotionObserver = new MutationObserver(suppressLegacyPromotions);
      promotionObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['style']
      });
    }

    var form = root.querySelector('.df-product-form');
    var variants = parseVariants(root);
    var optionControls = Array.prototype.slice.call(root.querySelectorAll('[data-df-option-input]'));
    var hiddenVariant = root.querySelector('[data-df-variant-id]');
    var price = root.querySelector('[data-df-price]');
    var compare = root.querySelector('[data-df-compare-price]');
    var klarnaAmounts = Array.prototype.slice.call(root.querySelectorAll('[data-df-klarna-amount]'));
    var addButton = root.querySelector('[data-df-add-button]');
    var addLabel = root.querySelector('[data-df-add-label]');
    var addToCartLabel = root.getAttribute('data-df-label-add-to-cart') || '';
    var soldOutLabel = root.getAttribute('data-df-label-sold-out') || '';
    var unavailableLabel = root.getAttribute('data-df-label-unavailable') || '';
    var ringSizeErrorLabel = root.getAttribute('data-df-label-ring-size-error') || '';
    var combinationUnavailableLabel = root.getAttribute('data-df-label-combination-unavailable') || '';
    var formError = root.querySelector('[data-df-form-error]');
    var gallery = initGallery(root);
    var requiresRingSize = root.getAttribute('data-df-requires-ring-size') === 'true';
    var ringSizeControl = root.querySelector('select[data-df-option-input]');
    var ringSizeError = root.querySelector('[data-df-ring-size-error]');
    var ringSizeOptionPosition = ringSizeControl ? Number(ringSizeControl.closest('[data-df-option]').getAttribute('data-option-position')) - 1 : -1;
    var internalRingSizeUpdate = false;

    function variantFromLocation() {
      var variantId = new URL(window.location.href).searchParams.get('variant');

      if (!variantId) {
        return null;
      }

      return variants.find(function(variant) {
        return String(variant.id) === String(variantId);
      }) || null;
    }

    var locationVariant = variantFromLocation();
    var explicitRingSizeValue = requiresRingSize && locationVariant && ringSizeOptionPosition >= 0
      ? locationVariant.options[ringSizeOptionPosition]
      : '';

    function writeRingSize(value) {
      if (!ringSizeControl) {
        return;
      }

      internalRingSizeUpdate = true;
      ringSizeControl.value = value || '';

      if (!value) {
        ringSizeControl.selectedIndex = 0;
      }

      internalRingSizeUpdate = false;
    }

    function enforceRingSizeState() {
      if (!requiresRingSize || !ringSizeControl) {
        return;
      }

      if (explicitRingSizeValue) {
        if (ringSizeControl.value !== explicitRingSizeValue) {
          writeRingSize(explicitRingSizeValue);
        }
        return;
      }

      if (ringSizeControl.value || ringSizeControl.selectedIndex !== 0) {
        writeRingSize('');
      }

      hiddenVariant.value = '';
    }

    enforceRingSizeState();

    function selectedOptions() {
      var values = [];

      root.querySelectorAll('[data-df-option]').forEach(function(group) {
        var position = Number(group.getAttribute('data-option-position')) - 1;
        var selected = group.querySelector('input[data-df-option-input]:checked, select[data-df-option-input]');

        if (selected) {
          values[position] = selected.value;
        }
      });

      return values;
    }

    function currentVariant() {
      var selected = selectedOptions();

      return variants.find(function(variant) {
        return variant.options.every(function(value, index) {
          return selected[index] !== undefined && selected[index] !== '' && selected[index] === value;
        });
      });
    }

    function previewVariant() {
      var selected = selectedOptions();

      return variants.find(function(variant) {
        return variant.options.every(function(value, index) {
          return !selected[index] || selected[index] === value;
        });
      });
    }

    function selectedFinish() {
      var control = root.querySelector('input[data-df-option-input][type="radio"]:checked');

      return control ? control.value : '';
    }

    function renderPriceAndGallery(variant) {
      var hasCompare = variant && variant.compareAtPrice > variant.price;

      if (!variant) {
        return;
      }

      price.textContent = variant.priceFormatted;
      compare.textContent = hasCompare ? variant.compareAtPriceFormatted : '';
      compare.hidden = !hasCompare;
      klarnaAmounts.forEach(function(klarnaAmount) {
        klarnaAmount.textContent = variant.klarnaFormatted;
      });
      gallery.showFinish(variant.featuredMediaId, selectedFinish());
    }

    function missingRingSize() {
      return requiresRingSize && (!ringSizeControl || !explicitRingSizeValue || ringSizeControl.value !== explicitRingSizeValue);
    }

    function clearRingSizeError() {
      if (!ringSizeControl || !ringSizeError) {
        return;
      }

      ringSizeControl.setAttribute('aria-invalid', 'false');
      ringSizeError.hidden = true;
      ringSizeError.textContent = '';
    }

    function showRingSizeError() {
      if (!ringSizeControl || !ringSizeError) {
        return;
      }

      ringSizeControl.setAttribute('aria-invalid', 'true');

      if (ringSizeError.hidden) {
        ringSizeError.textContent = ringSizeErrorLabel;
        ringSizeError.hidden = false;
      }

      ringSizeControl.focus({ preventScroll: true });
      ringSizeControl.scrollIntoView({
        behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
    }

    function setThemeAddToCartHook(enabled) {
      if (enabled) {
        addButton.setAttribute('data-btn-addtocart', '');
        addButton.setAttribute('data-form-id', '#add-to-cart-form');
        return;
      }

      addButton.removeAttribute('data-btn-addtocart');
      addButton.removeAttribute('data-form-id');
    }

    function renderVariant(variant) {
      if (missingRingSize()) {
        var finishPreview = previewVariant();

        hiddenVariant.value = '';
        renderPriceAndGallery(finishPreview);
        setThemeAddToCartHook(false);
        addButton.disabled = false;
        addLabel.textContent = addToCartLabel;
        formError.hidden = true;
        formError.textContent = '';
        return;
      }

      if (!variant) {
        hiddenVariant.value = '';
        setThemeAddToCartHook(false);
        addButton.disabled = true;
        addLabel.textContent = unavailableLabel;
        formError.hidden = false;
        formError.textContent = combinationUnavailableLabel;
        return;
      }

      hiddenVariant.value = variant.id;
      renderPriceAndGallery(variant);
      setThemeAddToCartHook(variant.available);
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? addToCartLabel : soldOutLabel;
      formError.hidden = true;
      formError.textContent = '';
      clearRingSizeError();

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      hiddenVariant.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    optionControls.forEach(function(control) {
      control.addEventListener('change', function(event) {
        if (control === ringSizeControl) {
          if (internalRingSizeUpdate) {
            return;
          }

          if (!event.isTrusted) {
            enforceRingSizeState();
            renderVariant(currentVariant());
            return;
          }

          explicitRingSizeValue = control.value || '';

          if (explicitRingSizeValue) {
            clearRingSizeError();
          }
        }

        enforceRingSizeState();
        renderVariant(currentVariant());
      });
    });

    if (requiresRingSize && ringSizeControl) {
      ['input', 'change'].forEach(function(eventName) {
        ringSizeControl.addEventListener(eventName, function(event) {
          if (!event.isTrusted && !internalRingSizeUpdate) {
            enforceRingSizeState();
          }
        }, true);
      });

      if (window.MutationObserver) {
        var ringSizeObserver = new MutationObserver(function() {
          enforceRingSizeState();
        });

        ringSizeObserver.observe(ringSizeControl, {
          attributes: true,
          attributeFilter: ['selected', 'value'],
          childList: true,
          subtree: true
        });
      }

      window.addEventListener('pageshow', function() {
        var restoredVariant = variantFromLocation();
        explicitRingSizeValue = restoredVariant && ringSizeOptionPosition >= 0
          ? restoredVariant.options[ringSizeOptionPosition]
          : '';
        enforceRingSizeState();
        renderVariant(currentVariant());
      });

      window.addEventListener('popstate', function() {
        var historyVariant = variantFromLocation();
        explicitRingSizeValue = historyVariant && ringSizeOptionPosition >= 0
          ? historyVariant.options[ringSizeOptionPosition]
          : '';
        enforceRingSizeState();
        renderVariant(currentVariant());
      });
    }

    if (form) {
      addButton.addEventListener('click', function(event) {
        if (missingRingSize()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          hiddenVariant.value = '';
          showRingSizeError();
        }
      }, true);

      form.addEventListener('invalid', function(event) {
        if (event.target === ringSizeControl && missingRingSize()) {
          event.preventDefault();
          hiddenVariant.value = '';
          showRingSizeError();
        }
      }, true);

      form.addEventListener('submit', function(event) {
        if (missingRingSize()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          hiddenVariant.value = '';
          showRingSizeError();
        }
      }, true);
    }

    initAccordions(root);
    initDelivery(root, form);
    initCoveredInfo(root);
    renderVariant(currentVariant());
  }

  function initAll() {
    document.querySelectorAll('[data-df-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
